import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getLiteral } from 'utils/getLiteral';
import TextField from 'material-ui/TextField';
import Literal from '../../../../../components/Literal';
import Button from '../../../../../components/Button';
import Dialog from 'components/ContextDialog';
import stylejs from './styles';
import './style.scss';

class ConfirmationDialog extends Component {
    state = {};

    renderInputDialog = () => {
        let literalPlaceholder = getLiteral('label_type_confirmation_word_salesforce');
        return (
            <div className="input-dialog">
                <TextField
                    id="input-domain"
                    className="textfield-element"
                    style={stylejs.inputDialog}
                    placeholder={literalPlaceholder}
                    onChange={this.handleDomainChange}
                />
            </div>
        );
    };

    handleDomainChange = (event) => {
        this.setState({ inputValue: event.target.value.toLowerCase() });
    };

    render() {
        let {
            showInputDialog,
            showDialog,
            showLoadingDialog,
            onClickCancel,
            onClickAccept,
            handleClose,
            literalTitle,
            literalDesc1,
            literalDesc2,
            literalDesc3,
            literalActionCancel,
            literalActionAccept,
        } = this.props;
        let { inputValue } = this.state;
        let literalConfirmationWord = getLiteral('label_confirmation_word_salesforce');
        let inputContent = showInputDialog ? this.renderInputDialog() : null;
        let disableButton =
            (showInputDialog && inputValue !== literalConfirmationWord.toLowerCase()) ||
            showLoadingDialog
                ? true
                : false;
        let dialogTitle = showInputDialog ? (
            <div>
                <div className="ic-warning-filled" />
                <Literal literal={literalTitle} />
            </div>
        ) : (
            <Literal literal={literalTitle} />
        );
        return showDialog ? (
            <Dialog
                title={dialogTitle}
                titleStyle={stylejs.titleDialogStyle}
                titleClassName="header-dialog"
                bodyClassName="body-dialog"
                bodyStyle={stylejs.bodyDialogStyle}
                modal={false}
                open={showDialog}
                onRequestClose={handleClose}
                className="confirmation-dialog-integrations dialogBlockOutsideClick"
                autoScrollBodyContent={true}
            >
                <i className="ic-close" onClick={handleClose} />
                <div className="dialog-text-container">
                    <Literal className="disableDialog-text" literal={literalDesc1} />
                    <Literal className="disableDialog-text-bold" literal={literalDesc2} />
                    <Literal className="disableDialog-text" literal={literalDesc3} />
                </div>
                {inputContent}
                <div className="footer-dialog">
                    <Button
                        text={<Literal literal={literalActionCancel} />}
                        onClick={onClickCancel}
                        type="primary"
                    />
                    <Button
                        text={<Literal literal={literalActionAccept} />}
                        onClick={onClickAccept}
                        disabled={disableButton}
                    />
                </div>
            </Dialog>
        ) : null;
    }
}

export default ConfirmationDialog;
